import { bakimHesapla } from '@/pages/bakim-takip/utils/bakimHesapla';

interface MusteriMesaj {
  id: string;
  ad: string;
  soyad: string;
  telefon: string;
  ilce: string;
  son_bakim_tarihi: string | null;
}

export type MesajFiltre = 'hepsi' | 'sari' | 'kirmizi';

interface Props {
  customers: MusteriMesaj[];
  secili: MesajFiltre;
  onChange: (f: MesajFiltre) => void;
}

export default function FiltreSecSupabase({ customers, secili, onChange }: Props) {
  const yesil  = customers.filter(c => c.son_bakim_tarihi && bakimHesapla(c.son_bakim_tarihi).durum === 'yesil').length;
  const sari   = customers.filter(c => c.son_bakim_tarihi && bakimHesapla(c.son_bakim_tarihi).durum === 'sari').length;
  const kirmizi= customers.filter(c => c.son_bakim_tarihi && bakimHesapla(c.son_bakim_tarihi).durum === 'kirmizi').length;

  const kartlar: { key: MesajFiltre; baslik: string; aciklama: string; sayi: number; ikon: string; activeBg: string; activeBorder: string; activeText: string; iconBg: string; iconColor: string; borderColor: string; badge: string }[] = [
    { key: 'hepsi', baslik: 'Tüm Müşteriler', aciklama: 'Kayıtlı tüm müşterilere mesaj gönder', sayi: customers.length, ikon: 'ri-group-line', activeBg: 'bg-slate-700', activeBorder: 'border-slate-700', activeText: 'text-white', iconBg: 'bg-slate-100', iconColor: 'text-slate-600', borderColor: 'border-gray-200', badge: 'bg-slate-100 text-slate-700' },
    { key: 'sari', baslik: 'Bakımı Yaklaşanlar', aciklama: 'Son bakımı 6-9 ay olan müşteriler', sayi: sari, ikon: 'ri-time-line', activeBg: 'bg-yellow-500', activeBorder: 'border-yellow-500', activeText: 'text-white', iconBg: 'bg-yellow-100', iconColor: 'text-yellow-600', borderColor: 'border-yellow-200', badge: 'bg-yellow-100 text-yellow-700' },
    { key: 'kirmizi', baslik: 'Bakımı Gecikenler', aciklama: 'Son bakımı 9+ ay olan acil müşteriler', sayi: kirmizi, ikon: 'ri-alarm-warning-line', activeBg: 'bg-red-500', activeBorder: 'border-red-500', activeText: 'text-white', iconBg: 'bg-red-100', iconColor: 'text-red-500', borderColor: 'border-red-200', badge: 'bg-red-100 text-red-700' },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {kartlar.map(k => {
        const isActive = secili === k.key;
        return (
          <button key={k.key} onClick={() => onChange(k.key)}
            className={`text-left p-5 rounded-xl border-2 transition-all duration-200 cursor-pointer w-full
              ${isActive ? `${k.activeBg} ${k.activeBorder}` : `bg-white ${k.borderColor} hover:border-opacity-60`}`}>
            <div className="flex items-start justify-between gap-2 mb-3">
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${isActive ? 'bg-white/20' : k.iconBg}`}>
                <i className={`${k.ikon} text-xl ${isActive ? 'text-white' : k.iconColor}`}></i>
              </div>
              <span className={`text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap ${isActive ? 'bg-white/25 text-white' : k.badge}`}>{k.sayi} kişi</span>
            </div>
            <p className={`text-sm font-bold ${isActive ? 'text-white' : 'text-gray-800'}`}>{k.baslik}</p>
            <p className={`text-xs mt-1 ${isActive ? 'text-white/75' : 'text-gray-400'}`}>{k.aciklama}</p>
          </button>
        );
      })}
    </div>
  );
}